import React, {
  useMemo,
  useCallback,
  useState,
  useRef,
  useEffect,
} from "react";
import SpecialSwiper from "@/components/SpecialSwiper";
import HotArea from "@/components/HotArea";
const Preiview = ({
  baseConfig,
  rectOptions,
  props,
  zIndex = 0,
  currentIndex = 0,
  onChange = () => {},
}) => {
  const commonConfig = useMemo(
    () => ({
      interval: props.interval,
    }),
    [],
  );
  const wrapperRect = useMemo(
    () => ({
      width: props.slideWidth,
      height: rectOptions.height,
      left: rectOptions.left,
      top: rectOptions.top,
    }),
    [],
  );
  const activeBanner = useMemo(
    () => ({
      width: rectOptions.subRectOptions[0].width,
      height: rectOptions.subRectOptions[0].height,
      left: rectOptions.subRectOptions[0].left - wrapperRect.left,
      top: rectOptions.subRectOptions[0].top - wrapperRect.top,
      opacity: props.subProps[0].opacity,
    }),
    [],
  );
  const normalBanner1 = useMemo(
    () => ({
      width: rectOptions.subRectOptions[1].width,
      height: rectOptions.subRectOptions[1].height,
      left: rectOptions.subRectOptions[1].left - wrapperRect.left,
      top: rectOptions.subRectOptions[1].top - wrapperRect.top,
      opacity: props.subProps[1].opacity,
    }),
    [],
  );
  const normalBanner2 = useMemo(
    () => ({
      width: rectOptions.subRectOptions[2].width,
      height: rectOptions.subRectOptions[2].height,
      left: rectOptions.subRectOptions[2].left - wrapperRect.left,
      top: rectOptions.subRectOptions[2].top - wrapperRect.top,
      opacity: props.subProps[2].opacity,
    }),
    [],
  );

  const hotImageRect = useMemo(() => rectOptions.subRectOptions[3], []);

  const swiperData = useMemo(() => {
    const result = [];
    props.banners.forEach((groups, groupIndex) => {
      groups.forEach((frame) => {
        frame.belongGroupIndex = groupIndex;
        result.push(frame);
      });
    });
    return result;
  }, []);

  useEffect(() => {
    // onChange(currentIndex);
    if (currentIndexMemory.current === currentIndex) return;
    for (let i = 0; i < swiperData.length; i++) {
      if (swiperData[i].belongGroupIndex === currentIndex) {
        specialSwiperRef.current?.setActiveIndex(i);
        break;
      }
    }
  }, [currentIndex, swiperData]);

  // const [activeIndex, setActiveIndex] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);
  const currentIndexMemory = useRef(0);

  // 缓存 onSlideChange 回调
  const handleSlideChange = useCallback((index) => {
    onChange(swiperData[index].belongGroupIndex);
    currentIndexMemory.current = swiperData[index].belongGroupIndex;
    setSlideIndex(index);
  }, []);

  const handleActiveClick = useCallback((item) => {
    if (item.jumpUrl) {
      window.open(item.jumpUrl, "_blank");
    }
  }, []);

  const currentSwiperData = useMemo(
    () => swiperData[slideIndex],
    [swiperData, slideIndex],
  );

  const carouselConfig = useMemo(() => {
    return {
      // 飞出态：移出到屏幕左侧，保持原大
      exit: {
        left: -activeBanner.width - 30,
        top: activeBanner.top,
        scale: 1,
        opacity: 1,
        width: activeBanner.width,
        height: activeBanner.height,
        opacity: activeBanner.opacity,
        zIndex: 5,
      },
      // 可见态 N 帧：配置第一帧和第二帧的位置和缩放
      visible: [
        {
          left: activeBanner.left,
          top: activeBanner.top,
          scale: 1,
          opacity: 1,
          width: activeBanner.width,
          height: activeBanner.height,
          opacity: activeBanner.opacity,
          zIndex: 2,
        }, // Frame 1 (激活)
        {
          left: normalBanner1.left,
          top: normalBanner1.top,
          width: normalBanner1.width,
          height: normalBanner1.height,
          opacity: normalBanner1.opacity,
          zIndex: 3,
        }, // Frame 2
        {
          left: normalBanner2.left,
          top: normalBanner2.top,
          width: normalBanner2.width,
          height: normalBanner2.height,
          opacity: normalBanner2.opacity,
          zIndex: 4,
        }, // Frame 3
      ],
      // 飞入态：从屏幕右侧外部准备平移进入 Frame 2 的位置
      enter: {
        left: wrapperRect.width + wrapperRect.left + 30,
        top: normalBanner2.top,
        width: normalBanner2.width,
        height: normalBanner2.height,
        zIndex: 2,
        opacity: normalBanner2.opacity,
      },
    };
  }, []);

  const specialSwiperRef = useRef(null);

  console.log(currentSwiperData, "currentSwiperData");

  // 开发模块效果
  return (
    <>
      <div
        style={{
          position: "absolute",
          left: wrapperRect.left,
          top: wrapperRect.top,
          width: wrapperRect.width,
          height: wrapperRect.height,
        }}
      >
        <SpecialSwiper
          items={swiperData}
          config={carouselConfig}
          wrapperWidth={wrapperRect.width}
          wrapperHeight={wrapperRect.height}
          autoPlay={true}
          autoPlayInterval={Number(commonConfig.interval) * 1000}
          onSlideChange={handleSlideChange}
          ref={specialSwiperRef}
          onClickActive={handleActiveClick}
        />
      </div>
      <div
        style={{
          position: "absolute",
          left: hotImageRect.left,
          top: hotImageRect.top,
          width: hotImageRect.width,
          height: hotImageRect.height,
          zIndex: 3,
        }}
      >
        <img
          style={{ width: "100%", height: "100%" }}
          src={currentSwiperData?.hotImageUrl}
          alt=""
        />
        {currentSwiperData?.hotArea?.map((hot, index) => (
          <HotArea hot={hot} key={index} />
        ))}
      </div>
    </>
  );
};

export default Preiview;
